require('../../../retail/shared/wdh-legacy/search/js/base/component-search.js');
(function ($) {
  window.DGS.OnLoad.getInstance().register(function () {
    $('.search-field-spot').on('click', function (e) {
      // hide the expanded desktop menu
      $('.component.navigation .component-content li.level1.open-menu > a').trigger('click', [true]);
    });
  });
})(jQuery);